export interface MatchPair {
  home: string;
  away: string;
  round: number;
}

/**
 * Generate a round-robin schedule using the Berger table algorithm.
 * Fixes the first team and rotates the rest clockwise each round.
 * Handles odd number of teams by adding a "BYE" placeholder.
 */
export function generateRoundRobin(teamIds: string[]): MatchPair[] {
  if (teamIds.length < 2) return [];

  const teams = [...teamIds];
  if (teams.length % 2 !== 0) teams.push("BYE");

  const n = teams.length;
  const matches: MatchPair[] = [];

  for (let round = 0; round < n - 1; round++) {
    for (let i = 0; i < n / 2; i++) {
      const home = teams[i];
      const away = teams[n - 1 - i];
      if (home !== "BYE" && away !== "BYE") {
        matches.push({ home, away, round: round + 1 });
      }
    }
    // Rotate: keep first fixed, move last to position 1
    const last = teams.pop()!;
    teams.splice(1, 0, last);
  }

  return matches;
}
